(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairBoothSetupController', VirtualFairBoothSetupController)

    VirtualFairBoothSetupController.$inject = ['$uibModal', 'SellerService' ,'ExpoService', 'VirtualFairService', 'AclService'];


    function VirtualFairBoothSetupController( $uibModal, SellerService, ExpoService, VirtualFairService, AclService) {
        var vm = this;


        vm.boothList             = '';
        vm.queryFlag             = false;
        vm.expo                  = '';
        vm.status                = [{name:'All'}, {name:'Booth sent'}, {name:'Booth not sent'}];
        vm.expoSelected          = '';
        vm.seller                = '';
        vm.sellerSelected        = '';
        vm.statusSelected        = [];
        vm.selectExpo            = selectExpo;
        vm.getByFilter           = getByFilter;
        vm.getSellers            = getSellers;
        vm.openInfoModal         = openInfoModal;
        vm.uploadModal           = uploadModal;
        vm.countResult           = 0;
        vm.countUniversity       = 0;
        vm.countAgent            = 0;
        vm.countGovernment       = 0;
        vm.countOther            = 0;


        function activate() {
            vm.selectExpo();
            vm.getSellers();

        }

        function selectExpo () {
            ExpoService.getExposVirtualFair().then(function(response){
                    vm.expo = response.data;
            }).catch(function(err) {

            });
        }

        function getSellers() {
            SellerService.getAllVirtualFair().then(function(response){
                vm.seller = response.data;
                vm.seller.unshift({id:0,name:"All"});
            }).catch(function(err) {

            });
        }

        function uploadModal(item) {
            VirtualFairService.getBooths(item).then(function(response){
                $uibModal.open({
                    templateUrl: 'templates/virtualfairs/booth-setup/upload/upload_booth_setup_template.modal.html',
                    controller: 'UploadModalBoothSetupController',
                    controllerAs:'vm',
                    resolve:
                    {
                        boothItem      : function () {
                            return item;
                        }
                    }

                });
            }).catch(function(err) {

            });

        }

        function openInfoModal(boothItem) {
            var template = '';
            var items    = '';

                template = 'templates/virtualfairs/booth-setup/info/booth_setup_template.modal.html';
                VirtualFairService.getBooths(boothItem).then(function(response){
                    items = response.data;
                    $uibModal.open({
                        templateUrl: template,
                        controller: 'InfoModalBoothSetupController',
                        controllerAs:'vm',
                        resolve:
                        {
                            boothItem  : function () {
                                return items;
                            }
                        }
                    });
                }).catch(function(err) {

                });
        }

        function getByFilter() {
            vm.query = {};

            if(typeof vm.sellerSelected !== 'undefined' &&  vm.sellerSelected.name !== 'All') {
                vm.query['seller']   = vm.sellerSelected.id;
            }

            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo'] = vm.expoSelected.id;
            }

            if(vm.statusSelected.name !== 'All')
                vm.query['status'] = vm.statusSelected.name;

            VirtualFairService.getByFilterBoothSetup(vm.query).then(function(response){
                vm.boothList       = response.data;
                vm.countUniversity = response.data.countType[0].university;
                vm.countAgent      = response.data.countType[0].agent;
                vm.countGovernment = response.data.countType[0].government;
                vm.countOther      = response.data.countType[0].other;
                vm.countResult     = Object.keys(response.data.data).length;
                vm.queryFlag       = true;
            }).catch(function(err) {
            });
        }
        activate();
    }

})();